import React from "react";
import { Button, Typography } from "antd";
import { CheckCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { AuthLayout } from "../auth-layout/AuthLayout";
import { useNavigate } from "react-router-dom";
import { useTranslation, Trans } from "react-i18next";

const { Text } = Typography;

const SuccessCard = styled.div`
  text-align: center;
  padding: 40px 20px;
  color: #FEFFFC;

  .success-icon {
    font-size: 64px;
    color: #EBFED1;
    margin-bottom: 24px;
  }

  .success-title {
    font-size: 28px;
    font-weight: 600;
    margin-bottom: 16px;
  }

  .success-description {
    font-size: 16px;
    opacity: 0.9;
    margin-bottom: 32px;
    line-height: 1.6;
  }
`;

const StyledButton = styled(Button)``;

export const RegisterSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <AuthLayout maxWidth={500}>
      <SuccessCard>
        <CheckCircleOutlined className="success-icon" />
        <div className="success-title">{t("registerSuccess.title")}</div>
        <div className="success-description">
          <Trans i18nKey="registerSuccess.description">
            Wysłaliśmy email weryfikacyjny na podany adres. <strong>Sprawdź swoją skrzynkę</strong> i kliknij w
            link, aby aktywować konto.
            <br />
            <br />
            <strong>Link jest ważny przez 24 godziny.</strong>
          </Trans>
        </div>
        <StyledButton block onClick={() => navigate("/login")}>
          {t("registerSuccess.goToLogin")}
        </StyledButton>
      </SuccessCard>
    </AuthLayout>
  );
};
